import * as requestFromServer from "./AllPackagesByCategoryApis";
import { UISlice } from "../UISlice";
import {
  AllPackagesByCategorySlice,
  setLoading,
} from "./AllPackagesByCategorySlice";

const { actions: AllPackagesByCategoryActions } = AllPackagesByCategorySlice;
const { actions: UIActions } = UISlice;

export const FetchAllPackageManagementByCategory =
  (categoryId = "", currentPage, sortKey, sortDirection = "asc", filterBy) =>
  (dispatch) => {
    dispatch(UIActions.openLoader());
    dispatch(setLoading(true));

    let fetchFunction = requestFromServer.fetchAllPackagesByCategoryApis;

    return fetchFunction(
      categoryId,
      currentPage,
      sortKey,
      sortDirection,
      filterBy
    )
      .then((response) => {
        if (response.data.status) {
          dispatch(
            AllPackagesByCategoryActions.setAllPackagesByCategoryData({
              data: response.data.data,
            })
          );
        }
      })
      .catch((error) => {
        dispatch(AllPackagesByCategoryActions.catchError(error));
      })
      .finally(() => {
        dispatch(UIActions.closeLoader());
        dispatch(setLoading(false));
      });
  };
